// ============================================================================
// URL publiques d'une SKILLCARD — imprimées dans le QR code du verso.
// ============================================================================
// Origine FIXE (jamais `window.location.origin`) : sur l'app native l'origine
// est `capacitor://localhost`, et une carte imprimée doit rester valable des
// années. Le QR encode l'URL COURTE `/c/{code}` (code court permanent, figé par
// le trigger `guard_card_publication_fields`) : moins de modules, QR plus gros
// et plus lisible à taille égale. Aucune donnée élève. Les cartes imprimées
// avant (QR vers `/card/{id}`) restent valables : la route existe toujours.
// ============================================================================

export const CARD_PUBLIC_ORIGIN = 'https://app.jeraisonne.fr';
export const CARD_SHORT_HOST = 'app.jeraisonne.fr';

/** Alphabet du code court : sans 0/O/1/I/L (lisible à la main). */
export const CARD_SHORT_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
export const CARD_SHORT_CODE_RE = /^[ABCDEFGHJKMNPQRSTUVWXYZ23456789]{6}$/;

/** Origine fournie (ex. `http://localhost:5173` en dev) sans slash final ; vide → origine publique. */
function resolveOrigin(origin?: string | null): string {
  const o = origin?.trim().replace(/\/+$/, '');
  return o || CARD_PUBLIC_ORIGIN;
}

/**
 * Lien vers la page publique d'une carte. `origin` sert aux LIENS cliqués
 * (site / app en dev → localhost) ; le QR imprimé reste sur l'origine publique.
 */
export function buildCardUrl(cardId: string, origin?: string | null): string {
  return `${resolveOrigin(origin)}/card/${cardId}`;
}

/** URL encodée dans le QR du verso : l'URL courte, avec son schéma (`https://…/c/ABC234`). */
export function buildCardQrUrl(shortCode: string, origin?: string | null): string {
  return `${resolveOrigin(origin)}/c/${shortCode}`;
}

/** URL de secours imprimée en petit au verso (`app.jeraisonne.fr/c/ABC234`). */
export function buildCardShortUrl(shortCode: string): string {
  return `${CARD_SHORT_HOST}/c/${shortCode}`;
}

export function normalizeCardShortCode(raw: string): string | null {
  const code = raw.trim().toUpperCase();
  return CARD_SHORT_CODE_RE.test(code) ? code : null;
}
